import { Breadcrumbs, Link, Typography } from '@mui/material';
import React from 'react'
import { Container, Col, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import "../../../Assets/css/mjstatic.css"
import { useSelector } from 'react-redux';
import { Address_details, Email_details, client_name } from '../../../Helpers/request';

const ShippingPolicy = () => {
    const Email_details_link = Email_details.link
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet>
            <div className="rcs_ringsetting_section mt-3">
                <Container>
                    <Row>
                        <Col className="rcs_breadcrumb m-0 mb-md-2">
                            <Breadcrumbs aria-label="breadcrumb">
                                <NavLink underline="hover" color="inherit" to="/">
                                    Home
                                </NavLink>
                                <Typography color="text.primary">Shipping Policy</Typography>
                            </Breadcrumbs>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <div className="rcs_privacy_content mt-5 mb-5">
                                <h1>Shipping Policy</h1>
                                {/* <h2>Introduction and Overview</h2> */}
                                <p>At Alicia's Jewelers, we strive for prompt and efficient shipping services to enhance your overall shopping experience. We endeavor to dispatch all orders in stock within 24 hours of receipt, excluding federal holidays, provided the order is placed before 12:00 noon EST on weekdays.</p>
                                <p>Special orders will be shipped upon completion expediously. Orders placed over the weekend will be processed and shipped on the following Monday.</p>
                                <p>Rest assured, all items are shipped fully insured and beautifully gift wrapped. For domestic orders exceeding $300 USD, shipping is complimentary. Please note that special expedited shipping requests may incur additional charges. Alicia's Jewelers is dedicated to promptly fulfilling your orders, aiming to dispatch them as swiftly as possible upon placement.</p>
                                <p>As a customer-focused establishment, we are committed to delivering products that exceed your expectations in quality. To achieve this, meticulous attention to detail and stringent quality control measures are paramount in our operations, ensuring your utmost satisfaction with every purchase you make.</p>
                                <h2>International Shipping</h2>
                                <p>We are pleased to offer international shipping services, with only a few exceptions (please contact us for clarification). It is essential to be aware that customs fees, import duties, or taxes might be imposed by the receiving country. These charges are the responsibility of the buyer. For detailed information regarding your country's customs policies, we recommend reaching out to your local customs office.</p>
                                <p>To facilitate a seamless ordering process and address any specific shipping requests, kindly email us before placing your order. Your satisfaction is our priority, and we are here to assist you.</p>
                                <p>If you have any inquiries or concerns about our shipping procedures, please do not hesitate to contact us at: +1 (877) 254-2427. We are here to assist you and ensure your shopping experience with Alicia's Jewelers is exceptional.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default ShippingPolicy;